import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Activity } from '../activity/activity';
import { DashboardService } from './dashboard.service'
import { HttpClient } from "@angular/common/http";
import { IsInfo } from '../_helpers/isInfo';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  @Output() childEvent: EventEmitter<any>  = new EventEmitter();


  lastrace : any;
  newlastrace : any;
  adventure : any;
  maplerace;


  constructor(private dashboardService : DashboardService, private httpClient: HttpClient, public isLoggedInSingleton: IsInfo, private titleService: Title) { 
    this.titleService.setTitle("Dashboard - VirtualRacesFrance"); 
    this.isLoggedInSingleton.checkInfo();
  }

  async ngOnInit() {
    await this.getAdventure();
    this.lastrace = await this.dashboardService.getLastRace().toPromise();

    if(this.lastrace){
      await this.getCityOfRace();
      this.newlastrace = this.lastrace;
    }else{
      this.newlastrace = {
        idRace: this.maplerace.citys[0].races[0],
        idCity : this.maplerace.citys[0],
        percentage : 0
      }
    }

  }

  async getCityOfRace(){
    for(let city in this.maplerace.citys){
      for(let race in this.maplerace.citys[city].races){
        if(this.lastrace.idRace._id == this.maplerace.citys[city].races[race]._id){
          this.lastrace['idCity'] = this.maplerace.citys[city];
          this.lastrace['percentage'] = ((this.lastrace.distanceRan * 100) /  this.maplerace.citys[city].races[race].distance);
        }

      }
    }
  }

  async getAdventure(){
    this.maplerace = await this.httpClient.get("../../assets/adventures/maplerace.json").toPromise();
  }
  


}
